/**
 * mc-collection.js — Manifesto
 *
 * Interatividade COMPARTILHADA do catálogo (sections/main-collection-manifesto)
 * e da busca (sections/main-search-manifesto) — task 0018 / DP-4. A raiz é
 * qualquer nó com [data-mc-catalog] (busca) ou o data-section-type do catálogo
 * (hook antigo preservado); toda a lógica abaixo é relativa a esse nó.
 *
 * Não depende do facets.js do Dawn — os filtros são nativos por URL param
 * (GET form). Aqui cuidamos de:
 *   1. Accordions dos FilterBlocks.
 *   2. Auto-submit do form de filtros no desktop (change em checkbox/preço).
 *   3. Sort (preserva filtros, navega com ?sort_by=).
 *   4. Overlay de filtros no mobile (abrir/fechar + lock de body); "Aplicar"
 *      é submit nativo do form mobile.
 *   4b. Bottom sheet do catálogo (task 0035/U1, gate AJ-1..AJ-14) — SÓ quando
 *      o overlay carrega [data-mc-sheet]: backdrop, foco (trap simples +
 *      retorno ao opener), contagem viva no CTA via Section Rendering API
 *      (debounce 350ms + AbortController + timeout 6s, fail-open p/ submit
 *      nativo) e estagiamento dos quick-links de ABV (AJ-9). A busca (0018)
 *      NÃO tem o atributo → comportamento byte-idêntico ao anterior.
 *   5. Busca client-side sobre os cards já renderizados (espelha o React).
 *   6. "Ver mais" — fetch da próxima página e append no grid; atualiza TODAS
 *      as ocorrências de [data-mc-showing] (0035/U4 tem 2 no catálogo) e a
 *      barra de progresso decorativa [data-mc-progress] (0035/U2, AJ-8).
 *
 * Lição 0009 (CLAUDE.md): SVG não reflete a propriedade .hidden — usar
 * setAttribute/removeAttribute('hidden') sempre.
 */

(function () {
  'use strict';

  function init() {
    // Raízes suportadas: busca ([data-mc-catalog]) e catálogo (hook legado).
    var roots = document.querySelectorAll(
      '[data-mc-catalog], [data-section-type="main-collection-manifesto"]'
    );
    Array.prototype.forEach.call(roots, initRoot);
  }

  function setHidden(el, hide) {
    if (!el) return;
    if (hide) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function initRoot(section) {
    if (!section || section.hasAttribute('data-mc-inited')) return;
    section.setAttribute('data-mc-inited', '');

    // 1. Accordions
    section.querySelectorAll('[data-mc-acc]').forEach(function (head) {
      head.addEventListener('click', function () {
        var block = head.closest('[data-mc-acc-block]');
        if (!block) return;
        var collapsed = block.hasAttribute('data-collapsed');
        if (collapsed) {
          block.removeAttribute('data-collapsed');
          head.setAttribute('aria-expanded', 'true');
        } else {
          block.setAttribute('data-collapsed', '');
          head.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // 2. Auto-submit (desktop)
    var deskForm = section.querySelector('[data-mc-filter-form]');
    if (deskForm) {
      deskForm.addEventListener('change', function (e) {
        if (e.target.matches('[data-mc-filter-input]')) {
          deskForm.submit();
        }
      });
    }

    // 2b. Preço no modelo do mock (0035 · ajuste do dono 5): dois CAMPOS
    // numéricos (carregam os name= — vazios = sem filtro, URL limpa) +
    // slider de 2 controles como enhancement sem name, sincronizados.
    section.querySelectorAll('[data-mc-price]').forEach(function (box) {
      var minI = box.querySelector('[data-mc-price-min]');
      var maxI = box.querySelector('[data-mc-price-max]');
      var minF = box.querySelector('[data-mc-price-min-field]');
      var maxF = box.querySelector('[data-mc-price-max-field]');
      var fill = box.querySelector('[data-mc-price-fill]');
      var floor = parseInt(box.getAttribute('data-floor'), 10) || 1;
      if (!minI || !maxI) return;

      function paint(lo, hi) {
        if (!fill) return;
        fill.style.left = (lo / floor) * 100 + '%';
        fill.style.right = (100 - (hi / floor) * 100) + '%';
      }
      // arrasto do slider → campos acompanham (extremo = campo vazio ⇒ sem param)
      function fromRanges() {
        var lo = parseInt(minI.value, 10) || 0;
        var hi = parseInt(maxI.value, 10); if (isNaN(hi)) hi = floor;
        // impede cruzamento dos thumbs
        if (lo > hi) {
          if (document.activeElement === minI) { lo = hi; minI.value = lo; }
          else { hi = lo; maxI.value = hi; }
        }
        if (minF) minF.value = lo > 0 ? String(lo) : '';
        if (maxF) maxF.value = hi < floor ? String(hi) : '';
        paint(lo, hi);
      }
      // digitação nos campos → slider acompanha (clamp 0..teto, sem cruzar)
      function fromFields() {
        var lo = minF && minF.value !== '' ? parseInt(minF.value, 10) || 0 : 0;
        var hi = maxF && maxF.value !== '' ? parseInt(maxF.value, 10) : floor;
        if (isNaN(hi)) hi = floor;
        lo = Math.max(0, Math.min(lo, floor));
        hi = Math.max(0, Math.min(hi, floor));
        if (lo > hi) { var t = lo; lo = hi; hi = t; }
        if (minF && minF.value !== '') minF.value = String(lo);
        if (maxF && maxF.value !== '') maxF.value = String(hi);
        minI.value = lo;
        maxI.value = hi;
        paint(lo, hi);
      }
      minI.addEventListener('input', fromRanges);
      maxI.addEventListener('input', fromRanges);
      if (minF) minF.addEventListener('change', fromFields);
      if (maxF) maxF.addEventListener('change', fromFields);
      paint(parseInt(minI.value, 10) || 0, parseInt(maxI.value, 10) || floor);
    });

    // 3. Sort
    function applySort(value) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
    section.querySelectorAll('[data-mc-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () { applySort(sel.value); });
    });

    // 4. Overlay mobile (busca) / bottom sheet (catálogo, 0035 — feature-detected)
    var overlay = section.querySelector('[data-mc-overlay]');
    var isSheet = !!(overlay && overlay.hasAttribute('data-mc-sheet'));
    var backdrop = section.querySelector('[data-mc-sheet-backdrop]');
    var openers = section.querySelectorAll('[data-mc-filters-open]');
    var closers = section.querySelectorAll('[data-mc-filters-close]');
    var lastFocus = null;

    function openOverlay() {
      if (!overlay) return;
      overlay.removeAttribute('hidden');
      if (backdrop) backdrop.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (isSheet) {
        lastFocus = document.activeElement;
        overlay.focus();
      }
    }
    function closeOverlay() {
      if (!overlay) return;
      overlay.setAttribute('hidden', '');
      if (backdrop) backdrop.setAttribute('hidden', '');
      document.body.style.overflow = '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (isSheet && lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
        lastFocus = null;
      }
    }
    openers.forEach(function (b) { b.addEventListener('click', openOverlay); });
    closers.forEach(function (b) { b.addEventListener('click', closeOverlay); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hasAttribute('hidden')) closeOverlay();
    });

    // 4b-i. Trap de foco do sheet (AJ-6) — Tab cicla dentro do dialog
    if (isSheet) {
      overlay.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusables = Array.prototype.filter.call(
          overlay.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
          ),
          // só visíveis — os checkboxes de ABV ficam ocultos no DOM (ajuste
          // do dono 2026-08-08) e não podem participar do ciclo do trap
          function (el) { return el.offsetParent !== null; }
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === overlay)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    // 4b-ii. Contagem viva do CTA (AJ-3/AJ-4/AJ-14) — Section Rendering API
    var mobileForm = section.querySelector('[data-mc-filter-form-mobile]');
    var ctaBtn = section.querySelector('[data-mc-sheet-cta]');
    var ctaLabel = section.querySelector('[data-mc-sheet-cta-label]');
    var ctaArrow = section.querySelector('[data-mc-sheet-arrow]');
    var ctaSpinner = section.querySelector('[data-mc-sheet-spinner]');
    var liveRegion = section.querySelector('[data-mc-sheet-live]');
    var collectionUrl = section.getAttribute('data-collection-url');
    var sectionId = section.getAttribute('data-section-id');

    if (
      isSheet && mobileForm && ctaBtn && ctaLabel && collectionUrl && sectionId &&
      window.fetch && window.AbortController && window.URLSearchParams
    ) {
      var countTimer = null;
      var countCtrl = null;

      function fmt(n) { return n.toLocaleString('pt-BR'); }
      function setIdle(n) {
        ctaLabel.textContent = n === 0
          ? 'Nenhum rótulo com esses filtros'
          : 'Ver ' + fmt(n) + (n === 1 ? ' rótulo' : ' rótulos');
        setHidden(ctaArrow, n === 0);
        setHidden(ctaSpinner, true);
        ctaBtn.removeAttribute('aria-busy');
        if (liveRegion) {
          liveRegion.textContent = n === 0
            ? 'Nenhum rótulo com esses filtros'
            : fmt(n) + (n === 1 ? ' rótulo encontrado' : ' rótulos encontrados');
        }
      }
      function setLoading() {
        // AJ-3: o número anterior permanece legível (contraste pleno);
        // só a seta vira spinner. O botão segue clicável (submit nativo).
        setHidden(ctaArrow, true);
        setHidden(ctaSpinner, false);
        ctaBtn.setAttribute('aria-busy', 'true');
      }
      function setError() {
        // Fail-open (AJ-14): rótulo genérico e honesto; submit nativo intacto.
        ctaLabel.textContent = 'Aplicar filtros';
        setHidden(ctaArrow, false);
        setHidden(ctaSpinner, true);
        ctaBtn.removeAttribute('aria-busy');
        if (liveRegion) liveRegion.textContent = 'Não foi possível atualizar a contagem';
      }

      function refreshCount() {
        if (countCtrl) countCtrl.abort();
        var ctrl = new AbortController();
        countCtrl = ctrl;
        var timedOut = false;
        var to = setTimeout(function () { timedOut = true; ctrl.abort(); }, 6000);
        var params = new URLSearchParams(new FormData(mobileForm));
        params.set('section_id', sectionId);
        setLoading();
        fetch(collectionUrl + '?' + params.toString(), { signal: ctrl.signal })
          .then(function (r) {
            if (!r.ok) throw new Error('http ' + r.status);
            return r.text();
          })
          .then(function (html) {
            clearTimeout(to);
            if (ctrl !== countCtrl) return; // já existe fetch mais novo
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var node = doc.querySelector('[data-mc-results-total]');
            var n = node ? parseInt(node.getAttribute('data-mc-results-total'), 10) : NaN;
            if (isNaN(n)) { setError(); return; }
            setIdle(n);
          })
          .catch(function (err) {
            clearTimeout(to);
            // aborto por fetch mais novo: silêncio (o mais novo assume)
            if (err && err.name === 'AbortError' && !timedOut && ctrl !== countCtrl) return;
            if (ctrl !== countCtrl) return;
            setError();
          });
      }

      mobileForm.addEventListener('change', function () {
        clearTimeout(countTimer);
        countTimer = setTimeout(refreshCount, 350);
      });

      // 4b-iii. Quick-links de ABV dentro do sheet (AJ-9): estagiam em vez de
      // navegar — marcam/desmarcam os checkboxes-membro e disparam change
      // (a contagem viva reage). Sem JS, o <a> navega (fallback nativo).
      mobileForm.addEventListener('click', function (e) {
        var link = e.target.closest('[data-mc-abv-members]');
        if (!link || !mobileForm.contains(link)) return;
        e.preventDefault();
        var param = link.getAttribute('data-mc-abv-param') || '';
        var members = (link.getAttribute('data-mc-abv-members') || '').split('|').filter(Boolean);
        var makeActive = !link.classList.contains('is-active');
        var boxes = mobileForm.querySelectorAll('input[type="checkbox"][data-mc-filter-input]');
        members.forEach(function (v) {
          Array.prototype.forEach.call(boxes, function (input) {
            if (input.name === param && input.value === v && !input.disabled) {
              input.checked = makeActive;
              // sincroniza o estado visual do label-membro (ressalva 4 do review)
              var lbl = input.closest('.mc-cat-check');
              if (lbl) lbl.classList.toggle('is-active', makeActive);
            }
          });
        });
        // estado visual otimista até o re-render server-side (href fica
        // obsoleto, mas está neutralizado pelo preventDefault)
        link.classList.toggle('is-active', makeActive);
        mobileForm.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // 5. Busca client-side
    var grid = section.querySelector('[data-mc-grid]');
    var noResults = section.querySelector('[data-mc-no-results]');
    var searchInputs = section.querySelectorAll('[data-mc-search]');
    function applySearch(term) {
      if (!grid) return;
      var q = (term || '').trim().toLowerCase();
      var visible = 0;
      grid.querySelectorAll('[data-mc-card]').forEach(function (cell) {
        var hay = (cell.getAttribute('data-title') || '') + ' ' + (cell.getAttribute('data-vendor') || '');
        var show = q.length < 2 || hay.indexOf(q) !== -1;
        cell.hidden = !show;
        if (show) visible++;
      });
      if (noResults) noResults.hidden = !(q.length >= 2 && visible === 0);
      // mantém os dois inputs sincronizados
      searchInputs.forEach(function (i) { if (i.value !== term) i.value = term; });
    }
    searchInputs.forEach(function (input) {
      input.addEventListener('input', function () { applySearch(input.value); });
    });

    // 6. Ver mais (load-more)
    var moreBtn = section.querySelector('[data-mc-load-more]');
    var showings = section.querySelectorAll('[data-mc-showing]');
    var progressFill = section.querySelector('[data-mc-progress]');
    var resultsTotalAttr = section.getAttribute('data-mc-results-total');

    function updateShowing(doc) {
      if (resultsTotalAttr !== null && grid) {
        // Catálogo 0035 (U2/U4): shown real = cards no grid; total do hook.
        var total = parseInt(resultsTotalAttr, 10) || 0;
        var shown = grid.querySelectorAll('[data-mc-card]').length;
        var text = 'Mostrando ' + shown + ' de ' + total + (total === 1 ? ' rótulo' : ' rótulos');
        showings.forEach(function (s) { s.textContent = text; });
        if (progressFill && total > 0) {
          progressFill.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';
        }
      } else if (doc) {
        // Busca (0018): comportamento legado — copia o texto renderizado.
        var newShowing = doc.querySelector('[data-mc-showing]');
        if (newShowing) {
          showings.forEach(function (s) { s.textContent = newShowing.textContent; });
        }
      }
    }

    if (moreBtn && grid) {
      moreBtn.addEventListener('click', function () {
        var nextUrl = moreBtn.getAttribute('data-next-url');
        if (!nextUrl) return;
        moreBtn.disabled = true;
        moreBtn.textContent = 'CARREGANDO…';
        fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-mc-grid]');
            if (newGrid) {
              Array.prototype.forEach.call(newGrid.children, function (li) {
                grid.appendChild(li.cloneNode(true));
              });
            }
            var newBtn = doc.querySelector('[data-mc-load-more]');
            updateShowing(doc);
            if (newBtn) {
              moreBtn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
              moreBtn.disabled = false;
              moreBtn.textContent = '+ VER MAIS CERVEJAS';
            } else {
              moreBtn.remove();
            }
            // reaplica busca aos cards novos
            var active = section.querySelector('[data-mc-search]');
            if (active && active.value) applySearch(active.value);
          })
          .catch(function () {
            moreBtn.disabled = false;
            moreBtn.textContent = '+ VER MAIS CERVEJAS';
          });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
